// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLocationByIdRequestModel from '../../model/get-location-by-id-request-model';
import GetLocationByIdRequestDTO from '../dto/get-location-by-id-request-dto';
import dtoSchema from '../schemas/get-location-by-id-request-schema';

export default abstract class GetLocationByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLocationByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetLocationByIdRequestDTO>): GetLocationByIdRequestModel;
  static toModel(dto: DeepPartial<GetLocationByIdRequestDTO> | undefined | null): GetLocationByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLocationByIdRequestDTO> | undefined | null): GetLocationByIdRequestModel | undefined {
    return dto ? new GetLocationByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLocationByIdRequestModel> | GetLocationByIdRequestModel): GetLocationByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetLocationByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetLocationByIdRequestModel, can not map to GetLocationByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
